<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-row justify="center" align="center">
              <v-col cols="12" md="2" sm="12" style="text-align: center; margin:0 auto">
                <v-avatar size="90">
                  <v-img src="https://paspor-gtk.belajar.kemdikbud.go.id/casgpo/asset/img/logo-kemdikbud.png" />
                </v-avatar>
              </v-col>
              <v-col cols="12" md="7" sm="12" class="text-center text-md-left text-xl-left">
                <h2 class="font-weight-regular">Selamat Datang di</h2>
                <h1 class="mb-1" style="font-size: 1.7em">
                  Aktivasi Akun
                  {{ k_profil_psp === 3 ? 'Pendamping Implementasi Pembelajaran (PIP)' : 'Peserta dan Fasilitator' }}
                </h1>
                <span class="mt-1 grey--text">Program Sekolah Penggerak 2021</span>
              </v-col>
              <v-col cols="12" md="3" sm="12" class="d-none d-sm-flex">
                <v-img :src="$imgUrl('bg_banner_register.jpg')" />
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="align-center text-center">
          <template v-if="tokenValid">
            <v-list-item-content v-if="step === 0">
              <validation-observer ref="observer" v-slot="{ errors }">
                <v-divider class="my-2" />
                <form>
                  <h1 class="headline green--text text-left">Selamat!</h1>
                  <p class="text-left body-2 mb-2">
                    Akun anda telah berhasil terdaftar di Program Sekolah Penggerak. Buatlah Kata Sandi untuk masuk
                    kedalam layanan kami.
                  </p>
                  <v-alert text color="info" class="text-left pa-3">
                    <div>
                      <small><b>Nama: </b>{{ nama }}</small>
                    </div>
                    <div>
                      <small><b>Surel: </b>{{ email }}</small>
                    </div>
                  </v-alert>
                  <template v-if="!is_paspor">
                    <validation-provider name="Kata Sandi" rules="required|confirmed:confirmation" mode="passive">
                      <v-subheader class="px-0 required" style="height: 25px">
                        Atur Kata Sandi Anda
                      </v-subheader>
                      <v-text-field
                        type="password"
                        v-model="form.password"
                        label="Kata Sandi"
                        required
                        placeholder="Masukkan Kata Sandi Anda"
                        filled
                        dense
                        outlined
                        single-line
                      />
                    </validation-provider>
                    <validation-provider name="Ulangi Kata Sandi" rules="required" vid="confirmation" mode="passive">
                      <v-subheader class="px-0 required" style="height: 25px">
                        Ulangi Kata Sandi
                      </v-subheader>
                      <v-text-field
                        type="password"
                        v-model="form.password_confirmation"
                        label="Ulangi Kata Sandi"
                        required
                        placeholder="Ulangi Kata Sandi baru Anda"
                        filled
                        dense
                        outlined
                        single-line
                      />
                    </validation-provider>
                  </template>
                  <template v-else>
                    <validation-provider name="Kata Sandi" rules="required" mode="passive">
                      <v-subheader class="px-0 required" style="height: 25px">
                        Masukkan Kata Sandi Layanan Akun SIMPKB Anda
                      </v-subheader>
                      <v-text-field
                        type="password"
                        v-model="form.password"
                        label="Kata Sandi"
                        required
                        placeholder="Masukkan Kata Sandi Anda"
                        filled
                        dense
                        outlined
                        single-line
                      />
                    </validation-provider>
                  </template>
                </form>
                <v-alert
                  prominent
                  text
                  dense
                  type="error"
                  class="caption mb-3"
                  v-if="showError(errors).length || msgError"
                >
                  <template v-if="showError(errors).length">
                    <ul class="text-left list-unstyled">
                      <li v-for="(item, i) in showError(errors)" :key="i">
                        {{ item }}
                      </li>
                    </ul>
                  </template>
                  <template v-else>{{ msgError }}</template>
                </v-alert>
                <div class="text-right">
                  <v-btn right color="primary" dark @click="onActivate" :loading="loading">
                    Aktifkan
                  </v-btn>
                </div>
              </validation-observer>
            </v-list-item-content>
            <v-list-item-content v-else>
              <h1 class="text-center mb-2">
                Aktivasi Akun Berhasil!
              </h1>
              <v-alert text dense type="success" class="caption mb-3" border="left">
                Selamat, Data akun Anda berhasil diaktifkan!.
              </v-alert>
              <div class="text-right">
                <v-btn color="primary" right dark @click="onLogin" :loading="loading">
                  Login
                </v-btn>
              </div>
            </v-list-item-content>
          </template>
          <template v-else>
            <v-list-item-content>
              <h1 class="text-center mb-2">
                Token Anda Tidak Valid!
              </h1>
              <v-alert prominent text dense type="error" class="caption mb-3" border="left">
                Token Anda tidak terdaftar pada Aplikasi, Anda dapat mengecek kembali url aktivasi yang dikirimkan ke
                alamat Surel Anda!.
              </v-alert>
              <div class="text-right">
                <v-btn color="primary" right dark @click="onLogin" :loading="loading">
                  Tutup
                </v-btn>
              </div>
            </v-list-item-content>
          </template>
        </v-list-item>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex';
import { arrayFlat } from '@utils/format';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
export default {
  name: 'aktivasi',
  components: { ValidationObserver, ValidationProvider },
  data() {
    return {
      loading: false,
      tokenValid: true,
      is_paspor: false,
      k_profil_psp: 1,
      msgError: '',
      step: 0,
      form: {},
      nama: null,
      email: null,
    };
  },
  created() {
    this.fetchAktivasi(this.token)
      .then((data) => {
        this.is_paspor = data?.is_paspor ?? this.is_paspor;
        this.nama = data?.data?.nama ?? this.nama;
        this.email = data?.data?.email ?? this.email;
        this.k_profil_psp = data?.data?.k_profil_psp ?? this.k_profil_psp;
      })
      .catch(() => {
        this.tokenValid = false;
      });
  },
  mounted() {
    this.onReset();
  },
  computed: {
    token() {
      return this.$route.params.token;
    },
  },
  methods: {
    ...mapActions('auth', ['aktivasi', 'fetchAktivasi']),

    onReset() {
      this.step = 0;
      this.tokenValid = true;
      this.form = {};
      this.$refs.observer.reset();
    },

    showError(errors) {
      const listError = Object.values(errors).filter((errors) => errors.length);
      return arrayFlat(listError);
    },

    async onActivate() {
      this.valid = await this.$refs.observer.validate();
      if (this.valid) {
        this.loading = true;
        this.aktivasi(Object.assign({}, this.form, { token: this.token }))
          .then(() => {
            this.step = 1;
            this.loading = false;
            this.$success('Akun Anda Berhasil diaktivasi!');
          })
          .catch((resp) => {
            this.loading = false;
            this.msgError = resp;
          });
      }
    },

    onLogin() {
      window.location.href = process.env.VUE_APP_API_URL + `/psp/auth/login`;
    },
  },
};
</script>

<style lang="css" scoped>
.required:after {
  content: '*';
  color: red;
  padding: 3px;
}
</style>
